(function () {
  // Both ws-project-overview and ws-gallery-modal include this file, so it's
  // common for the same <script src="..."> tag to appear more than once on a
  // page. The browser re-executes this whole IIFE for every extra tag, so
  // guard the entry point itself instead of relying only on the per-element
  // dataset flags below.
  if (window.__wsGalleryLoaded) return;
  window.__wsGalleryLoaded = true;

  function findModal(targetHandle) {
    var modals = document.querySelectorAll('[data-ws-gallery-modal]');
    if (!modals.length) return null;

    if (targetHandle) {
      for (var i = 0; i < modals.length; i++) {
        if (modals[i].getAttribute('data-ws-gallery-modal') === targetHandle) {
          return modals[i];
        }
      }
    }

    return modals[0];
  }

  function lockScroll(lock) {
    document.documentElement.classList.toggle('ws-gallery-scroll-lock', lock);
  }

  function openModal(modal) {
    modal.hidden = false;
    requestAnimationFrame(function () {
      modal.classList.add('is-open');
    });
    lockScroll(true);
  }

  function closeModal(modal) {
    modal.classList.remove('is-open');
    lockScroll(false);
    closeLightbox(modal);
    window.setTimeout(function () {
      modal.hidden = true;
    }, 200);
  }

  function getItems(modal) {
    return Array.prototype.slice.call(modal.querySelectorAll('[data-ws-gallery-item]'));
  }

  function renderLightboxContent(modal, item) {
    var content = modal.querySelector('[data-ws-gallery-lightbox-content]');
    if (!content) return;
    content.innerHTML = '';

    if (item.getAttribute('data-ws-gallery-type') === 'video') {
      var template = item.querySelector('template');
      if (template) {
        content.appendChild(template.content.cloneNode(true));
        var video = content.querySelector('video');
        if (video) video.play().catch(function () {});
      }
    } else {
      var img = document.createElement('img');
      img.src = item.getAttribute('data-ws-gallery-full') || item.getAttribute('data-ws-gallery-thumb');
      img.alt = item.getAttribute('data-ws-gallery-alt') || '';
      content.appendChild(img);
    }
  }

  function openLightbox(modal, index) {
    var items = getItems(modal);
    if (!items.length) return;
    index = ((index % items.length) + items.length) % items.length;

    var lightbox = modal.querySelector('[data-ws-gallery-lightbox]');
    if (!lightbox) return;

    lightbox.setAttribute('data-current-index', index);
    renderLightboxContent(modal, items[index]);
    lightbox.hidden = false;
    requestAnimationFrame(function () {
      lightbox.classList.add('is-open');
    });
  }

  function closeLightbox(modal) {
    var lightbox = modal.querySelector('[data-ws-gallery-lightbox]');
    if (!lightbox) return;
    lightbox.classList.remove('is-open');
    var content = lightbox.querySelector('[data-ws-gallery-lightbox-content]');
    window.setTimeout(function () {
      lightbox.hidden = true;
      if (content) content.innerHTML = '';
    }, 150);
  }

  function stepLightbox(modal, delta) {
    var lightbox = modal.querySelector('[data-ws-gallery-lightbox]');
    if (!lightbox || lightbox.hidden) return;
    var current = parseInt(lightbox.getAttribute('data-current-index'), 10) || 0;
    openLightbox(modal, current + delta);
  }

  function bindModal(modal) {
    if (modal.dataset.wsGalleryBound) return;
    modal.dataset.wsGalleryBound = 'true';

    modal.addEventListener('click', function (event) {
      if (event.target.closest('[data-ws-gallery-close]')) {
        if (event.target.closest('[data-ws-gallery-lightbox]')) {
          closeLightbox(modal);
        } else {
          closeModal(modal);
        }
        return;
      }

      if (event.target.closest('[data-ws-gallery-prev]')) {
        stepLightbox(modal, -1);
        return;
      }

      if (event.target.closest('[data-ws-gallery-next]')) {
        stepLightbox(modal, 1);
        return;
      }

      var item = event.target.closest('[data-ws-gallery-item]');
      if (item) {
        var items = getItems(modal);
        openLightbox(modal, items.indexOf(item));
        return;
      }

      if (event.target === modal) {
        closeModal(modal);
      }
    });

    document.addEventListener('keydown', function (event) {
      if (modal.hidden) return;
      if (event.key === 'Escape') {
        var lightbox = modal.querySelector('[data-ws-gallery-lightbox]');
        if (lightbox && !lightbox.hidden) {
          closeLightbox(modal);
        } else {
          closeModal(modal);
        }
      } else if (event.key === 'ArrowLeft') {
        stepLightbox(modal, -1);
      } else if (event.key === 'ArrowRight') {
        stepLightbox(modal, 1);
      }
    });
  }

  function bindTriggers(scope) {
    (scope || document).querySelectorAll('[data-ws-gallery-trigger]').forEach(function (trigger) {
      if (trigger.dataset.wsGalleryTriggerBound) return;
      trigger.dataset.wsGalleryTriggerBound = 'true';

      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        var target = trigger.getAttribute('data-ws-gallery-trigger') || '';
        var modal = findModal(target);
        if (modal) openModal(modal);
      });
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-ws-gallery-modal]').forEach(bindModal);
    bindTriggers(scope);
  }

  document.addEventListener('DOMContentLoaded', function () {
    init(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
